import React from 'react';

export const ErrorIcon = ({height=64, width=64}) => {
    const cls1 = {
        fill: "none",
        stroke: "#FF0000",
        strokeWidth: 35,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10
    };

    return (

        <svg version="1.1" id="Layer_1" height={height} width={width} x="0px" y="0px" viewBox="0 0 512 512"
             style={{enableBackground: "new 0 0 512 512;"}}>

            <polygon style={cls1} points="250.7901,48.8625 24.2979,433.1776 487.7021,433.1776 "
                     id="id_101"></polygon>
            <g>
                <path d="M256,173.9362c3.1303,3.2315,5.7856,6.4631,8.2664,9.6946c1.2897,1.6158,2.3926,3.2315,3.598,4.8473
		c1.1111,1.6158,2.2431,3.2315,3.3004,4.8473c0.208,0.4039,0.2932,0.8079,0.2375,1.2118c-0.0468,0.4039-0.1979,0.8079-0.2915,1.2118
		c-0.1055,0.4039-0.1202,0.8079-0.1108,1.2118v1.2118v4.8473v9.6946v38.7785v38.7785v19.3893l-3.349,4.8473
		c-1.1918,1.6158-2.3101,3.2315-3.5791,4.8473c-2.4592,3.2316-5.0625,6.4631-8.072,9.6946
		c-3.0095-3.2315-5.6127-6.4631-8.072-9.6946c-1.269-1.6158-2.3873-3.2315-3.5791-4.8473L241,309.661v-19.3893v-38.7785v-38.7785
		v-9.6946v-4.8473v-1.2118c0.0094-0.4039-0.0052-0.8079-0.1108-1.2118c-0.0936-0.4039-0.2447-0.8079-0.2915-1.2118
		c-0.0557-0.4039,0.0294-0.8079,0.2375-1.2118c1.0572-1.6158,2.1892-3.2315,3.3003-4.8473c1.2054-1.6158,2.3083-3.2316,3.598-4.8473
		C250.2144,180.3993,252.8697,177.1677,256,173.9362z" id="id_102"></path>
            </g>
            <circle cx="256" cy="371.1742" r="15.8911" id="id_103"></circle>
        </svg>
    )
};